import API from "../../../../../global/api";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from "moment";
import { PDFHeader } from "../../../../../global/globalFunctions";


export const requestTrialBalanceSearch = () => {
    return {
        type: "REQUEST_TRIAL_BALANCE_SEARCH",
    };
};
export const successTrialBalanceSearch = (data) => {
    return {
        type: "SUCCESS_TRIAL_BALANCE_SEARCH",
        payload: data,
    };
};
export const errorTrialBalanceSearch = () => {
    return {
        type: "ERROR_TRIAL_BALANCE_SEARCH",
    };
};
export const TrailBalanceSearchApi = (data) => {
    return (dispatch) => {
        dispatch(requestTrialBalanceSearch());
        API.post(`/reports/trail_balance`, data).then((res) => {
            let getData = res.data;
            dispatch(successTrialBalanceSearch(getData));
        }).catch((error) => {
            dispatch(errorTrialBalanceSearch());
        })
    };
};


export const requestTrialBalancePDF = () => {
    return {
        type: "REQUEST_TRIAL_BALANCE_PDF",
    };
};
export const successTrialBalancePDF = (data) => {
    return {
        type: "SUCCESS_TRIAL_BALANCE_PDF",
        payload: data,
    };
};
export const errorTrialBalancePDF = () => {
    return {
        type: "ERROR_TRIAL_BALANCE_PDF",
    };
};
export const TrailBalancePDFAPi = (data) => {
    return async (dispatch) => {
        try {
            dispatch(requestTrialBalancePDF());
            const { data: getData } = await API.post(`/reports/trail_balance_pdf`, data);
            dispatch(successTrialBalancePDF(getData));
            generateTrialBalancePDF(getData, data);
        } catch (error) {
            console.log(error);
            dispatch(errorTrialBalancePDF());
        }
    };
};
const generateTrialBalancePDF = (getData, filters) => {
    const unit = "pt";
    const size = "A4";
    const orientation = "l";
    const doc = new jsPDF(orientation, unit, size);
    PDFHeader(doc, "Trail Balance Report");

    doc.setFontSize(12)
    doc.setFont("Times New Roman", "bold")
    doc.text(`Date From: ${filters.startDate} - Date To: ${filters.endDate}`, 50, 130);
    doc.setFontSize(11)
    doc.setFont("Times New Roman", "Normal")
    let currentY = 140;

    getData.forEach((level1) => {
        currentY = renderLevelHeader(
            doc,
            currentY,
            `${level1.key}-${level1.name}`,
            level1.levelBalance,
            level1.levelBalanceSign
        );

        level1?.levelTwoArray?.forEach((level2) => {
            currentY = renderLevelHeader(
                doc,
                currentY,
                `${level2.allKey}-${level2.levelTwoName}`,
                level2.levelBalance,
                level2.levelBalanceSign
            );

            level2?.levelThreeArray?.forEach((level3) => {
                currentY = renderLevelHeader(
                    doc,
                    currentY,
                    `${level3.allLevlKey}-${level3.levelThreeName}`,
                    level3.levelBalance,
                    level3.levelBalanceSign
                );

                currentY = renderLevelFourTable(doc, currentY, level3.levelFourArray);
            });
        });
    });

    doc.setProperties({ title: `Trial Balance - ${moment().format("YYYY-MM-DD")}.pdf`, });
    doc.output("dataurlnewwindow");
};
const renderLevelHeader = (doc, startY, title, balance, sign) => {
    doc.autoTable({
        startY,
        head: [[title, `${balance.toLocaleString()}/- ${sign}`]],
        body: [],
        columnStyles: {
            0: { cellWidth: 500 },
            1: { cellWidth: 100 },
        },
    });

    return doc.lastAutoTable.finalY + 5;
};
const renderLevelFourTable = (doc, startY, levelFourArray = []) => {
    if (!levelFourArray.length) return startY;

    const body = [];
    const totals = [0, 0, 0, 0, 0, 0];

    levelFourArray.forEach((item) => {
        const t = item.transactions?.[0];
        if (!t) return;

        const openingDr = t.opening_balance_sign == 2 ? t.opening_balance : 0;
        const openingCr = t.opening_balance_sign == 1 ? t.opening_balance : 0;
        const closingDr = t.closing_balance_sign == 2 ? t.closing_balance : 0;
        const closingCr = t.closing_balance_sign == 1 ? t.closing_balance : 0;

        body.push([
            item.allLevelKey,
            item.levelFourName,
            `${openingDr}/-`,
            `${openingCr}/-`,
            `${t.debitSum}/-`,
            `${t.creditSum}/-`,
            `${closingDr}/-`,
            `${closingCr}/-`,
        ]);

        totals[0] += openingDr;
        totals[1] += openingCr;
        totals[2] += t.debitSum;
        totals[3] += t.creditSum;
        totals[4] += closingDr;
        totals[5] += closingCr;
    });

    // Add totals row
    body.push([
        "",
        "TOTAL",
        ...totals.map((t) => `${t}/-`),
    ]);

    doc.autoTable({
        startY,
        head: [[
            "CODE",
            "DESCRIPTION",
            "OPENING DR",
            "OPENING CR",
            "DURING DR",
            "DURING CR",
            "CLOSING DR",
            "CLOSING CR",
        ]],
        body,
        tableLineColor: [189, 195, 199],
        tableLineWidth: 0.75,
        alternateRowStyles: { fillColor: [231, 215, 252] },
    });

    return doc.lastAutoTable.finalY + 10;
};